export enum UserTypes {
  GUEST = 'Guest',
  CANDIDATE = 'Candidate',
  EMPLOYER = 'Employer',
  INTERNAL = 'Internal',
}
